import { OnboardingTemplate } from 'src/interfaces/onboarding'
import { getCollectDataTemplateStepTitle } from 'src/utils/collectDataTemplate'

export const getOnBoardingStepsNames = (
  onboardingTemplates: OnboardingTemplate[] | undefined,
  templateId?: string,
): string => {
  if (!templateId) {
    return ''
  }
  const currentTemplate = onboardingTemplates?.find((item) => item.id === templateId)

  if (!currentTemplate?.collectDataTemplateSteps?.length) {
    return ''
  }

  return currentTemplate.collectDataTemplateSteps
    .map((step) => getCollectDataTemplateStepTitle(step))
    .join(', ')
}
